import "react-international-phone/style.css";
import Modal from "../modal/index.ts";
import RequestQuoteForm from "../forms/RequestQuoteForm";

const RequestQuote = (props) => {
	return (
		<Modal
			{...props}
			size="md"
			centered
			scrollable
			contentClassName="!bg-white border-0 shadow-2xl"
			dialogClassName="modal-dialog-sharp"
		>
			{/* Top accent bar */}
			<div className="h-1 bg-brand-500 w-full rounded-t" />

			<Modal.Header
				className={`border-b border-slate-200 px-8 pt-5 pb-5`}
				closeButtonClassName="w-8 h-8 rounded-full border border-slate-200 flex items-center justify-center text-slate-400 ha:border-slate-400 ha:text-slate-600 transition-colors"
			>
				<div>
					<p className="text-[11px] uppercase tracking-widest text-slate-400 font-medium mb-1">
						Shipping
					</p>
					<h3 className="text-xl font-medium text-slate-900 leading-tight">
						Compare courier rates
					</h3>
				</div>
			</Modal.Header>

			<Modal.Body className="px-8 pb-8 pt-6">
				<RequestQuoteForm onHide={props.onHide} />
			</Modal.Body>
		</Modal>
	);
};

export default RequestQuote;
